import { BRAND } from '../data/brand.js'

export default function BrandLockup({
  className = '',
  markClassName = '',
  wordmarkClassName = '',
  label = BRAND.name,
}) {
  return (
    <span className={`inline-flex items-center ${className}`} role="img" aria-label={label}>
      <img
        src={BRAND.mark}
        alt=""
        aria-hidden="true"
        className={`shrink-0 object-contain ${markClassName}`}
      />
      <span className={wordmarkClassName} style={{ fontFamily: "'Tyros Pro', sans-serif" }}>
        {BRAND.name}
      </span>
    </span>
  )
}
